export default __webpack_public_path__ + "static/media/clients-03.c16c566c.svg";